<template>
  <div class="h100 vh100 d-flex d-col">
    <Setup2FA />
  </div>
</template>

<script setup>
import Setup2FA from "@/components/Auth/2FASetup/2FASetup.vue";
</script>
